class JournalEventController extends AbstractController
	@register()
	@inject '$uibModal',
		'JournalEventRepository'
		'SEARCH_CONFIGURATION'

	initialize: ->
		@journalEvents = []
		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.journal_event
			sortProperty: 'timestamp'
			itemsCount: 0
		})

	getQuery: ->
		return @JournalEventRepository.createQuery()

	search: ->
		@searching = true

		query = @filterDTO.getQuery()
		query.with 'shop', 'register', 'user'

		@JournalEventRepository
			.getEntities query
			.then (response) =>
				@journalEvents = response
				@filterDTO.itemsCount = @journalEvents.length

				for event in @journalEvents
					event.type_label = event.entity_type.toLowerCase()

				@searching = false

	showData: (event) ->
		@$uibModal.open
			templateUrl: '@app/journal-event/modals/journal-event.modal.html'
			size: 'md'
			bindToController: true
			controllerAs: 'dataModal'
			controller: ($uibModalInstance, event) ->
				$onInit: ->
					@$uibModalInstance = $uibModalInstance
					@event = event

					if _.isString(@event.additional_data)
						@event.additional_data = JSON.parse(@event.additional_data)
			resolve:
				event: => event
